import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Breadcrumb from "../Breadcrumb";
import { withRouter } from "react-router";
import { Accordion } from "react-bootstrap";
import parse from "html-react-parser";

import CreateGetUsefulLinksAction from "../../store/actionCreators/CreateGetUsefulLinksAction";

class PublicUsefulLinksPage extends Component {
    constructor() {
        super();

        this.doLogin = this.doLogin.bind(this);

        this.state = {
            collapsed: true,
            userIsAuthenticated: false
        };
    }

    async componentDidMount() {
        this.props.getUsefulLinks();

        try {
            // Call server to check if the user is authenticated
            const res = await fetch("/Account/whoami", { credentials: "include" });
            if (res.ok) {
                const user = await res.json();
                this.setState({ userIsAuthenticated: !!user.username });
            } else {
                this.setState({ userIsAuthenticated: false });
            }
        } catch (err) {
            console.error("Error checking authentication:", err);
            this.setState({ userIsAuthenticated: false });
        }
    }

    doLogin() {
        const { history } = this.props;

        // Call to check if already logged in
        fetch("/Account/whoami", { credentials: "include" })
            .then(res => res.json())
            .then(user => {
                if (user.username) {
                    // Already logged in, go to dashboard
                    history.push("/dashboard");
                } else {
                    // Not logged in, redirect to MVC login page
                    window.location.href = "/Account/Login";
                }
            })
            .catch(err => {
                console.error("Error checking login status:", err);
                // fallback to login page
                window.location.href = "/Account/Login";
            });
    }

    render() {
        const t = this.props.t;

        return (
            <React.Fragment>
                <Breadcrumb
                    role=""
                    homeLink={t("Common.ButtonText.Home")}
                    pageName={t("PublicUsefulLinksPage.UsefulLinks")} />

                <div className="row">
                    <div className="col-md-12">
                        <div className="h5 text-center">{t("PublicUsefulLinksPage.UsefulLinks")}</div>
                    </div>
                </div>
                <hr className="srl-hr" />
                <div className="mb-5">  
                    {
                        this.props.usefulLinks.length > 0 &&
                        <Accordion flush>
                            {
                                this.props.usefulLinks.map((x, index) => {
                                    return (
                                        <Accordion.Item key={index} eventKey={x.id}>
                                            <Accordion.Header><strong>{x.name}</strong></Accordion.Header>
                                            <Accordion.Body>
                                                {parse(x.description)}
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    );
                                })
                            }
                        </Accordion>
                    }
                </div>
                <p>&nbsp;</p>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        usefulLinks: state.usefulLinks || []
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getUsefulLinks: () => {
            dispatch(CreateGetUsefulLinksAction());
        }
    };
};

const languageAwareComponent = withTranslation()(withRouter(PublicUsefulLinksPage));

export default connect(mapStateToProps, mapDispatchToProps)(languageAwareComponent);